/* =================================================================
   br-pdp-ingredients — pause the ingredient marquee when nobody can
   see it.

   WHY: the marquee is a CSS transform loop (br-pdp-ingredients.css,
   `br-marquee … linear infinite`), so it runs on the compositor and
   costs no main-thread work per frame. What it DOES cost, forever, is
   a composited layer holding the 2x-duplicated track and its twenty
   decoded images — being animated is what keeps that layer promoted
   and resident. On a tab left open for hours the loop is still
   ticking behind the footer, or behind another tab entirely, for
   nothing. This pauses it when the section is off-screen and when the
   tab is hidden, and resumes it exactly where it stopped.

   NOT an iteration cap. Stopping after N loops would park the track
   mid-scroll with cards clipped at both edges and no way to reach
   them (the viewport is overflow:hidden), and would make what a
   visitor sees depend on how long the tab had been open.

   Progressive enhancement, like br-faq-cards.js: without JS, or
   without IntersectionObserver, the marquee simply runs as it always
   has. Nothing is hidden or stopped by this file that CSS alone would
   not already show. Under prefers-reduced-motion the CSS has already
   removed the animation, so there is nothing here to pause.
   ================================================================= */
(function () {
  /* One registry per page. The theme editor re-executes section
     scripts on re-render, and a second instance would keep its own
     `wired` list that the document listeners below never reach.
     Sections added after load arrive through shopify:section:load. */
  if (window.__brIngredientsMarqueeInit) return;
  window.__brIngredientsMarqueeInit = true;

  var SELECTOR = '.br-pdp-ingredients__viewport';
  var PAUSED = 'br-pdp-ingredients__viewport--paused';

  /* Resume slightly before the section reaches the viewport, so it is
     never caught standing still in the first painted frame. */
  var ROOT_MARGIN = '100px 0px';

  var wired = [];

  function sync(entry) {
    /* document.hidden covers the background-tab case: Chrome throttles
       hidden tabs but does not necessarily drop the compositor layer. */
    entry.viewport.classList.toggle(PAUSED, !entry.onScreen || document.hidden);
  }

  function wire(root) {
    if (!('IntersectionObserver' in window)) return;

    (root || document).querySelectorAll(SELECTOR).forEach(function (viewport) {
      /* The theme editor re-executes section scripts on re-render;
         re-observing the same element would leak observers. */
      if (viewport.__brIngredientsMarquee) return;
      viewport.__brIngredientsMarquee = true;

      var entry = { viewport: viewport, onScreen: false };
      wired.push(entry);

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (record) {
            entry.onScreen = record.isIntersecting;
          });
          sync(entry);
        },
        { rootMargin: ROOT_MARGIN, threshold: 0 }
      );
      observer.observe(viewport);
    });
  }

  document.addEventListener('visibilitychange', function () {
    wired.forEach(sync);
  });

  document.addEventListener('shopify:section:load', function (event) {
    wire(event.target);
  });

  wire(document);
})();
